module.exports = __webpack_public_path__ + "static/effective-2396a57d632e5928ee39da3b1c611c76.png";